import React, { useRef, memo, useState } from 'react'
import { Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ScanListItem from './ScanListItem.jsx'
import JobModal from './Jobs/JobModal'
import DisposalModal from './DisposalModal'

const ScanList = memo(
    ({
        scanItems,
        setScanItems,
    }) => {
        const ref = useRef()
        const { t } = useTranslation()
        const [rfidJob, setRfidJob] = useState(null)
        const [rfidDisposal, setRfidDisposal] = useState(null)

        const handleDeletePosition = (scanId) => {
            let index = scanItems.findIndex((item) => item.scanId === scanId)
            if (index >= 0) {
                const newItems = [...scanItems]
                newItems.splice(index, 1)
                setScanItems(newItems)
            }
        }
        const handleEditPosition = (scanId) => {
            let scanObj = scanItems.find((item) => item.scanId === scanId)
            if (scanObj) {
                setRfidJob(scanObj)
            }
        }
        const handleDisposedPosition = (scanId) => {
            let scanObj = scanItems.find((item) => item.scanId === scanId)
            if (scanObj) {
                setRfidDisposal(scanObj)
            }
        }
        const handleCloseJobModal = async (closed) => {
            if (closed) {
                handleDeletePosition(rfidJob.scanId)
            }
            setRfidJob(null)
        }
        const handleCloseDisposalModal = async (disposed) => {
            if (disposed) {
                handleDeletePosition(rfidDisposal.scanId)
            }
            setRfidDisposal(null)
        }
        const renderPosition = (position, index) => {
            return (
                <ScanListItem
                    key={position.scanId}
                    position={position}
                    handleDeletePosition={handleDeletePosition}
                    handleEditPosition={handleEditPosition}
                    handleDisposedPosition={handleDisposedPosition}
                    index={index}
                />
            )
        }

        return (
            <div ref={ref} >
                <h2>{t('returnsReceiptOverlayProgress:positions')}</h2>
                <div className='spacing-down'>
                    {scanItems.length === 0 && (
                        <Alert variant='info'>
                            {t('returnsProcessingPage:noPositions')}
                        </Alert>
                    )}
                    {scanItems.map((item, index) => renderPosition(item, index))}
                </div>
                {rfidDisposal ? (
                    <DisposalModal
                        scanCodeObj={rfidDisposal}
                        handleClose={handleCloseDisposalModal}
                    />
                ) : null}
                {rfidJob ? (
                    <JobModal
                        scanCode={rfidJob.rfid}
                        handleClose={handleCloseJobModal}
                        isFirstScan={!rfidJob.wasAlreadyScaned}
                    />
                ) : null}
            </div>
        )
    }
)

export default ScanList
